module.exports = __webpack_public_path__ + "img/SX.dde608cd.png";